import { useCandidatesOverviewContext } from '../../Contexts/CandidatesOverviewContext/CandidatesOverviewContext';
import BaseFilter from './BaseFilter';
import StatusFilterPanel from './StatusFilterPanel';
import UIStrings from '@/Utils/UIStrings';

function StatusFilterButton() {
    const { filterBy } = useCandidatesOverviewContext();

    return (
        <BaseFilter label={UIStrings.ApplicantStatus} activeFilterCount={filterBy.length}>
            <StatusFilterPanel />
        </BaseFilter>
    );
}

export default StatusFilterButton;
